var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveShift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:book-remove-multiple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.2708 41.6666H10.4167V12.5H6.25V41.6666C6.25 42.7717 6.68899 43.8315 7.47039 44.6129C8.25179 45.3943 9.3116 45.8333 10.4167 45.8333H28.7708C28.0046 44.5552 27.4951 43.1398 27.2708 41.6666ZM39.5833 4.16663H29.1667V14.5833L25 11.4583L20.8333 14.5833V4.16663H18.75C17.6449 4.16663 16.5851 4.60561 15.8037 5.38701C15.0223 6.16842 14.5833 7.22822 14.5833 8.33329V33.3333C14.5833 34.4384 15.0223 35.4982 15.8037 36.2796C16.5851 37.061 17.6449 37.5 18.75 37.5H27.2708C27.5742 35.7034 28.2667 33.9948 29.2998 32.4939C30.3329 30.9931 31.6816 29.7362 33.2514 28.8113C34.8213 27.8865 36.5744 27.316 38.3879 27.1399C40.2014 26.9637 42.0315 27.1862 43.75 27.7916V8.33329C43.75 7.22822 43.311 6.16842 42.5296 5.38701C41.7482 4.60561 40.6884 4.16663 39.5833 4.16663ZM46.9583 35.1666L42.5208 39.5833L46.9583 44L44 46.9583L39.5833 42.5208L35.1667 46.9583L32.2083 44L36.6458 39.5833L32.2083 35.1666L35.1667 32.2083L39.5833 36.6458L44 32.2083L46.9583 35.1666Z",
    fill: "#F6931E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveShift);
export default __webpack_public_path__ + "static/media/removeShift.005b6f6021099623da88841c832bdb2b.svg";
export { ForwardRef as ReactComponent };